import { GroupFallbackProps } from './types'
import { Typography } from 'antd'

/**
 * @see {@link GroupFallbackProps}
 */
function GroupFallback({ group }: GroupFallbackProps) {
  return (
    <Typography.Paragraph>
      No {group} have been configured for this Project
    </Typography.Paragraph>
  )
}

export default GroupFallback
